var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircleSolid = function SvgInfoCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.371 0 0 5.42 0 12c0 6.629 5.371 12 12 12 6.58 0 12-5.371 12-12 0-6.58-5.42-12-12-12m0 5.323c1.113 0 2.032.919 2.032 2.032 0 1.161-.92 2.032-2.032 2.032-1.161 0-2.032-.87-2.032-2.032 0-1.113.87-2.032 2.032-2.032m2.71 12.29c0 .339-.29.58-.581.58H9.871a.56.56 0 0 1-.58-.58v-1.161c0-.29.241-.581.58-.581h.58v-3.097h-.58a.56.56 0 0 1-.58-.58v-1.162c0-.29.241-.58.58-.58h3.097c.29 0 .58.29.58.58v4.839h.581c.29 0 .58.29.58.58z"
  })));
};
export default SvgInfoCircleSolid;